import { TElement } from "@udecode/plate-common";
import { z } from "zod";

export const zFeedRecordRichText = z.array(
    z.object({
        type: z.union([z.literal("paragraph"), z.literal("heading"), z.literal("super-heading")]),
        children: z.array(
            z.object({
                text: z.string().default(""),
                bold: z.literal(true).optional(),
                italic: z.literal(true).optional(),
            })
        ),
    })
);

type tRecord = {
    title: string;
    content: TElement[];
    background: string;
};

// NOTE: Colors used in the rich text editor are defined in index.css.
export const recordTypes = {
    blunder: {
        title: "Blunder",
        content: [
            {
                type: "super-heading",
                children: [{ text: "??BLUNDER??", bold: true }],
            },
        ],
        background: "#FF2A00",
    },
    mistake: {
        title: "Mistake",
        content: [
            {
                type: "super-heading",
                children: [{ text: "??MISTAKE??", bold: true }],
            },
        ],
        background: "#FF8000",
    },
    great_move: {
        title: "Great move",
        content: [
            {
                type: "super-heading",
                children: [{ text: "!!GREAT MOVE!!", bold: true }],
            },
        ],
        background: "#5AD7FF",
    },
    low_on_time: {
        title: "Low on time",
        content: [
            {
                type: "super-heading",
                children: [{ text: "LOW ON TIME!!", bold: true }],
            },
        ],
        background: "#CCFF50",
    },
    opening: {
        title: "Opening",
        content: [
            {
                type: "super-heading",
                children: [{ text: "NAME OPENING", bold: true }],
            },
        ],
        background: "#F78DFF",
    },
} as const satisfies Record<string, tRecord>;

export type FeedRecordPreset = keyof typeof recordTypes;
